module.exports = __webpack_public_path__ + "img/brand_11.16c2bced.png";